export * from './prizm-paginator.component';
export * from './interfaces/prizm-paginator.interface';
export * from './prizm-paginator.module';
